<script>
  import dayjs from 'dayjs'
  import localizedFormat from 'dayjs/plugin/localizedFormat'
  import Card from '../../../components/card.svelte'
  import DataTable from '../../../components/data_table.svelte'

  dayjs.extend(localizedFormat)

  // Each is { records, total_count, shown }: the newest rows plus the real total.
  let { given = { records: [], total_count: 0 }, received = { records: [], total_count: 0 } } = $props()

  const kindClass = (kind) => (kind === 'mute' ? 'badge badge-secondary' : 'badge badge-error')
</script>

{#snippet truncationNote(list)}
  {#if (list?.total_count ?? 0) > (list?.records?.length ?? 0)}
    <p class="text-xs text-base-content/60 mt-2">Showing latest {list.records.length} of {list.total_count}.</p>
  {/if}
{/snippet}

{#snippet blockTable(rows, otherLabel)}
  <DataTable items={rows} emptyMessage="None.">
    {#snippet header()}
      <tr>
        <th>{otherLabel}</th>
        <th>Kind</th>
        <th>Date</th>
      </tr>
    {/snippet}
    {#snippet row(block)}
      <tr>
        <td>
          <a href={block.other_user.url} class="link link-hover">
            {block.other_user.name || block.other_user.id}
          </a>
        </td>
        <td><span class={kindClass(block.kind)}>{block.kind_label}</span></td>
        <td>{dayjs(block.created_at).format('ll')}</td>
      </tr>
    {/snippet}
  </DataTable>
{/snippet}

<Card title="Blocks & Mutes Given">
  {#snippet actions()}
    <span class="badge badge-ghost">{given.total_count}</span>
  {/snippet}
  {@render blockTable(given.records, 'Blocked User')}
  {@render truncationNote(given)}
</Card>

<Card title="Blocks & Mutes Received">
  {#snippet actions()}
    <span class="badge badge-ghost">{received.total_count}</span>
  {/snippet}
  {@render blockTable(received.records, 'Blocked By')}
  {@render truncationNote(received)}
</Card>
